<button [type]="type"
[style.opacity]="disabled ? 0.5 : 1"
[style.background]="fieldButton === 'field' ? colors[color] : hover ? '' : '#D5E8CF'"
[style.width]="'100%'"
[style.padding]=" size == 'middle' ? '8px' : '12px'"
[style.border]="(fieldButton == 'outline' && border) ? 'solid 1px black' : 'none'"
[style.color]="'#101F10'"
[style.border-radius]="'8px'"
[style.font-weight]="'bold'"
[style.display]="'flex'"
[style.justify-content]="'center'"
[style.align-items]="'center'"
[style.gap]="'8px'"
[style.cursor]="'pointer'"
>
    @if(icon && iconPosition == 'left') {
        <span class="material-symbols-outlined">
            {{icon}}
        </span>
    }
    <ng-content></ng-content>
    @if(icon && iconPosition == 'right') {
        <span class="material-symbols-outlined">
            {{icon}}
        </span>
    }
</button>
